import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageOncePerDay } from '../utils/analyticsTracker';

const usePageTracking = (user) => {
    const location = useLocation();
    useEffect(() => {
        if (user?.id && user?.name && user?.email) {
            trackPageOncePerDay(location.pathname, user);
        }
    }, [location.pathname, user]);
};

export default usePageTracking;
